<template>
  <div class="col-12 p-0">
    <div class="item-box text-center p-3">
      <h1
        class="fs-14 fc-6"
      >{{data.isFinished === true ? data.league || data.league_name : $matchDate(data.dateTime)}}</h1>
      <span
        class="fs-12 fc-3"
      >{{ data.court || data.court_name}} {{data.tv != null && data.tv != "" ? " - " + data.tv : null }}</span>

      <div class="team-band">
        <div class="team-block">
          <div class="team one">
            <img style="width: 100px;" class="img-responsive" :src="data.homeTeam.logo_url" alt />
            <p
              class="fs-14 fc-2"
              style="    line-height: 14px;
    height: 42px;"
            >{{ data.homeTeam.name }}</p>
          </div>
        </div>
        <div class="skor" style="width: 100px">
          <div class="detail">
            <p class="hour">{{data.homeTeam.score}} : {{data.awayTeam.score}}</p>
          </div>
        </div>
        <div class="team-block">
          <div class="team one">
            <img style="width: 100px;" class="img-responsive" :src="data.awayTeam.logo_url" alt />
            <p
              class="fs-14 fc-2"
              style="    line-height: 14px;
    height: 42px;"
            >{{ data.awayTeam.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters bg-2 bb-1 bt-1">
      <div
        style="display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;"
        class="block-link text-center pt-3 pb-3"
        v-if="data.isFinished == true"
        @click="$router.push({name: 'HomeAfterMatch', params: {id: data.id}})"
      >
        <h1 class="fc-1 fs-14">
          <img src="/static/img/arrow-left.svg" class="mr-2" />
          Maç Detayına Git
        </h1>
      </div>

      <div
        style="display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;"
        class="block-link text-center pt-3 pb-3"
        v-if="data.ticketLink != '' && data.ticketLink != null && data.isFinished == false"
      >
        <h1 class="fc-1 fs-14">
          <a
            class="fc-1"
            target="_blank"
            :href="data.ticket_link == undefined ? data.ticketLink : data.ticket_link"
          >
            <img src="/static/img/arrow-left.svg" class="mr-2" /> Maça Bilet Al
          </a>
        </h1>
      </div>

      <div
        v-if="hideAll == undefined"
        class="block-link text-center pt-3 pb-3"
        @click="$router.push({name: 'Fixture'})"
        style="display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;"
      >
        <h1 class="fc-1 fs-14">
          <img src="/static/img/two-dot.svg" class="mr-2" /> Tüm Maçları Göster
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MatchVS",
  props: ["data", "hideAll"]
};
</script>


// WEBPACK FOOTER //
// src/components/MatchVS.vue